export enum PackageEnum {
  OC_1 = "oc-1",
  OC_2 = "oc-2",
  OC_3 = "oc-3",
  OC_4 = "oc-4",
  OC_6 = "oc-6",
  OC_12 = "oc-12",
  OC_24 = "oc-24",

  OWC_1 = "owc-1",
  OWC_2 = "owc-2",
  OWC_3 = "owc-3",
  OWC_4 = "owc-4",
  OWC_6 = "owc-6",
  OWC_12 = "owc-12",
  OWC_24 = "owc-24",
}
